import React from 'react';
import ChooseMethodDF from '../components/SimulatorsComponents/DefualtSimulators/ChooseMethodDF';

//= ========================================================================

const Sim_D01_PayBillsChooseMethod = ({
  globJSON,
  simPlatform,
  slideshowRefs,
}) => (
  <ChooseMethodDF
    globJSON={globJSON}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_D01_PayBillsChooseMethod;
